import { createSelector } from '@ngrx/store';

import { ICustomer } from '@ruby/modules/customer-select/models/customer.interface';
import { selectCurrentCustomerSelected } from '@ruby/modules/customer-select/store/selectors/customers.selectors';
import { selectOrderFillFiltersFeatureState, State } from '@ruby/shared/inventory-management/order-history-header/store';
import * as fromOrderFillHeader from '@ruby/shared/inventory-management/order-history-header/store/reducers/order-history-filters.reducer';

export const selectOrderFillFiltersState = createSelector(
  selectOrderFillFiltersFeatureState,
  (state: State) => state[fromOrderFillHeader.featureKey]
);

export const selectOrderFiltersState = createSelector(
  selectOrderFillFiltersState,
  selectCurrentCustomerSelected,
  (
    state: fromOrderFillHeader.State,
    customer?: ICustomer
  ) => ({
    state,
    customer
  })
);
